import React, { useContext } from 'react';

export const AppContext = React.createContext({});

export const getBase = document =>
  document.baseURI || document.getElementsByTagName('base')[0].href;

const brands = ['chevrolet', 'buick', 'gmc', 'cadillac'];

const searchToQueryParamsDictionary = () =>
  location.search
    .replace('?', '')
    .split('&')
    .map(x => x.split('='))
    .reduce((hash, x) => {
      hash[x[0]] = x[1];
      return hash;
    }, {});

const queryParams = searchToQueryParamsDictionary();

const programs = {
  'family-first': 'ff',
  'dealership-employee': 'de',
  college: 'co',
  educator: 'ed',
  military: 'mi',
  supplier: 'su',
  'first-responder': 'fr'
};

const normalizeBodyStyles = (bodyStylesByBrand, language, country) => {
  let result = [];

  for (const brand in bodyStylesByBrand) {
    const bodyStyles = bodyStylesByBrand[brand].map(x => {
      const { image, msrp, bodyStyle, displayName, type, style, drpUrls } = x;
      const { code, model, year } = bodyStyle;

      return {
        image,
        msrp,
        language,
        displayName,
        country,
        brand,
        year,
        type,
        style,
        carline: model,
        bodyStyle: code,
        drpUrls
      };
    });
    result.push(...bodyStyles);
  }

  return result;
};

export const AppProvider = props => {
  const contextPath = window.CONTEXT_PATH;
  const uiPath = window.UI_PATH;
  const defaultYear = parseInt(queryParams['year']) || window.data.defaultYear;
  const { years, bodyStyles, types } = window.data;
  const { origin, pathname } = location;
  const baseUrl = getBase(document);
  const basePath = baseUrl.replace(origin, '');
  const [program, language, country] = pathname
    .replace(basePath, '')
    .split('/');
  const variant = programs[program] || 'ff';

  const hasMultipleQueryParams = Object.keys(queryParams).length > 1;
  const toReplace = `${hasMultipleQueryParams ? '' : '?'}year=${defaultYear}`;
  const urlWithoutYear = location.href.replace(toReplace, '');
  history.replaceState({ path: urlWithoutYear }, null, urlWithoutYear);

  return (
    <AppContext.Provider
      value={{
        language,
        country,
        variant,
        contextPath,
        uiPath,
        baseUrl,
        defaultYear,
        years,
        brands,
        types,
        bodyStyles: normalizeBodyStyles(bodyStyles, language, country)
      }}>
      {props.children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);

export default AppContext;
